import { useEffect, useState } from 'react';

export const useGetDataWithLoading = (func: () => Promise<any>): boolean => {
  const [isLoading, setLoading] = useState<boolean>(false);

  const getData = async () => {
    try {
      setLoading(true);
      await func();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return isLoading;
};
